export default __webpack_public_path__ + "resources/icons/d331-e5e6.png";